<template>
  <v-form ref="formEndereco" lazy-validation>
    <v-layout row wrap>
      <v-flex md4 sm12>
        <v-text-field
          v-model="endereco.cep"
          class="jns-input"
          label="CEP"
          placeholder="80999-999"
          v-mask="['#####-###']"
          :rules="[rules.obrigatorio, rules.cepIvalido]"
          :readonly="readonly"
          @change="getViaCEP"
        ></v-text-field>
      </v-flex>

      <v-flex md8 sm12>
        <v-text-field
          v-model="endereco.logradouro"
          class="jns-input"
          :label="
            lograduroCompacto
              ? 'Logradouro, número e complemento'
              : 'Logradouro'
          "
          :placeholder="
            lograduroCompacto
              ? 'Rua XV de Novembro, 1224, Ap 5 bloco B'
              : 'Rua XV de Novembro'
          "
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
        ></v-text-field>
      </v-flex>

      <template v-if="!lograduroCompacto">
        <v-flex md4 sm12>
          <v-text-field
            v-model="endereco.numero"
            v-mask="['XX#######']"
            class="jns-input"
            label="Número"
            placeholder="1224"
            :rules="numberRequired ? [rules.obrigatorio] : []"
            :readonly="readonly"
          ></v-text-field>
        </v-flex>

        <v-flex md8 sm12>
          <v-text-field
            v-model="endereco.complemento"
            class="jns-input"
            label="Complemento"
            placeholder="Ap 5 bloco B"
            :readonly="readonly"
          ></v-text-field>
        </v-flex>
      </template>

      <v-flex md4 sm12>
        <v-text-field
          v-model="endereco.bairro"
          class="jns-input"
          label="Bairro"
          placeholder=" "
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
        ></v-text-field>
      </v-flex>

      <v-flex md4 sm12>
        <v-text-field
          v-model="endereco.cidade"
          class="jns-input"
          label="Cidade"
          placeholder=" "
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
        ></v-text-field>
      </v-flex>

      <v-flex md4 sm12>
        <v-autocomplete
          v-model="endereco.uf"
          :no-data-text="'Nenhum resultado encontrado.'"
          :items="$settings.estados"
          :item-value="'value'"
          :item-text="'nome'"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          class="form-select-box"
          label="Estado"
          placeholder="Selecionar"
        ></v-autocomplete>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script lang="js">
export default {
  name: "RepresententesComponent",
  data() {
    return {
      alert: true,
      rules: {
        obrigatorio: (v) =>
          !!v || this.disabledValidation || "Campo obrigatório",
        cepIvalido: (v) =>
          new RegExp("\\d{5}[-]\\d{3}").test(v) || (v||'').replace("-", "").length == 8 || "Cep inválido",
      },
    };
  },
  props: {
    endereco: {
      type: Object, default: () => { }
    },
    readonly: { type: Boolean, default: false },
    lograduroCompacto: { type: Boolean, default: true },
    numberRequired:{ type: Boolean, default: true }
  },
  methods: {
    getViaCEP() {
      if (((this.endereco||{}).cep || '').replace("-", "").length == 8) {
        try {
        this.$viaCep
          .buscarCep(this.endereco.cep.replace("-", ""))
          .then((endereco) => {
            if (!("erro" in endereco)) {
              this.endereco.logradouro =
                endereco.logradouro || this.endereco.logradouro;
              this.endereco.bairro = endereco.bairro || this.endereco.bairro;
              this.endereco.cidade =
                endereco.localidade || this.endereco.bairro;
              this.endereco.uf = endereco.uf || this.endereco.bairro;
            }
            this.$forceUpdate();
          });

        } catch (error) {
          return
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ./src/components/EnderecoComponent.vue